import { useQuery } from 'data-fetching-client';
import { GET_ACTIVE_QUOTE_PUBLIC_ID } from 'pricing-pages-api/quotes/queries';
import { useCallback, useState } from 'react';
import { useAppSelector } from '../../../reducers';
import { isAppAuthSelector } from '../../../selectors/AuthSelectors';
import { logApiError, logApiSuccess } from '../../utils/apiLogging';
import { useIsUngatedForM1HubPages } from '../gating/useIsUngated';
export const useActiveQuoteBanner = ({
  apiNames,
  skip = false
} = {}) => {
  var _data$activeQuotePubl;
  const [isClosed, setIsClosed] = useState(false);
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const isM1HubPages = useIsUngatedForM1HubPages();
  const version = isM1HubPages ? 'v2' : 'v1';
  const handleCompleted = useCallback(() => {
    logApiSuccess({
      queryName: 'GET_ACTIVE_QUOTE_PUBLIC_ID',
      operation: 'getActiveQuotePublicId',
      version
    });
  }, [version]);
  const handleError = useCallback(error => {
    logApiError(error, {
      queryName: 'GET_ACTIVE_QUOTE_PUBLIC_ID',
      operation: 'getActiveQuotePublicId',
      version
    });
  }, [version]);
  const {
    data,
    loading,
    error
  } = useQuery(GET_ACTIVE_QUOTE_PUBLIC_ID, {
    variables: {
      apiNames
    },
    skip: skip || !isAppAuth,
    onCompleted: handleCompleted,
    onError: handleError
  });
  const activeQuotePublicId = data === null || data === void 0 || (_data$activeQuotePubl = data.activeQuotePublicId) === null || _data$activeQuotePubl === void 0 ? void 0 : _data$activeQuotePubl.activeQuotePublicId;
  const shouldShowActiveQuoteBanner = Boolean(activeQuotePublicId) && !isClosed;
  const handleClickClose = () => {
    setIsClosed(true);
  };
  return {
    shouldShowActiveQuoteBanner,
    activeQuotePublicId,
    handleClickClose,
    loading,
    error
  };
};